import * as React from "react";
import type { SVGProps } from "react";
const SvgBrain = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.821}
      d="M43.052 8.935c0-.865-.72-2.091-1.081-2.596-3.634-3.807-7.714-1.586-9.3 0v21.63M43.051 8.934c1.947-.487 5.191-.173 6.921 2.595.65.793 1.817 2.985 1.298 5.408m-8.219-8.003c-.865.216-2.682 1.168-3.028 3.244m11.247 4.758c1.37.793 4.066 3.374 3.893 7.354 0 1.01-.389 3.374-1.946 4.759M51.27 16.937c-.36.938-1.687 2.726-4.11 2.38m6.057 9.733c1.946 1.441 5.45 5.666 3.893 11.03-.649 1.586-2.595 4.932-5.191 5.624m1.298-16.654c-.793-.65-3.028-1.558-5.624 0m4.326 16.654c.36 2.307-.346 7.267-6.056 8.651m6.056-8.651c-.649.288-2.293.692-3.677 0m-2.38 8.651c-.36 1.803-2.292 5.408-7.137 5.408-1.441-.073-4.715-.909-6.272-3.677V35.755m13.41 18.6c-.433-.072-1.384-.432-1.73-1.297"
    />
    <path
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.821}
      d="M38.298 17.586c.937.937 3.417 2.25 5.84 0M43.13 29.218c-.937.937-2.25 3.417 0 5.84M42.72 43.513c-1.28.345-3.654 1.84-2.913 5.061M32.519 16.727H22.11v-5.204M31.478 48.992H22.11v5.204M32.523 32.339H14.829M32.52 25.054H17.43l-5.725-8.326M32.52 40.667H17.43l-5.725 8.326"
    />
    <circle
      cx={12.222}
      cy={31.82}
      r={2.732}
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeWidth={1.821}
    />
    <circle
      cx={10.144}
      cy={50.554}
      r={2.732}
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeWidth={1.821}
    />
    <circle
      cx={21.589}
      cy={55.757}
      r={2.732}
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeWidth={1.821}
    />
    <circle
      cx={10.144}
      cy={14.125}
      r={2.732}
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeWidth={1.821}
    />
    <circle
      cx={21.589}
      cy={8.921}
      r={2.732}
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeWidth={1.821}
    />
  </svg>
);
export default SvgBrain;
